const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const rankForgeService = {
    // Listar todos os artigos
    getAll: async (token) => {
        const response = await fetch(`${API_URL}/rank-forge`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Falha ao buscar artigos');
        }
        return response.json();
    },

    // Criar novo artigo
    create: async (data, token) => {
        const response = await fetch(`${API_URL}/rank-forge`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            throw new Error('Falha ao criar artigo');
        }
        return response.json();
    },

    // Obter detalhes do artigo
    getById: async (id, token) => {
        const response = await fetch(`${API_URL}/rank-forge/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Falha ao buscar detalhes do artigo');
        }
        return response.json();
    },
    // Deletar artigo
    delete: async (id, token) => {
        const response = await fetch(`${API_URL}/rank-forge/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Falha ao deletar artigo');
        }
        return response.json();
    },

    // Regerar artigo
    regenerate: async (id, token) => {
        const response = await fetch(`${API_URL}/rank-forge/${id}/regenerate`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error('Falha ao regerar artigo');
        }
        return response.json();
    },
};

export default rankForgeService;
